module.exports = __webpack_public_path__ + "img/system42-details.bf31bb9d.png";